import { gql } from '@apollo/client'

export const ADD_TEAM_MEMBER = gql`
  mutation AddTeamMember($id: ID!, $teamMemberID: ID!, $emailOrPhone: String!) {
    addTeamMember(input: { id: $id, teamMember: { id: $teamMemberID, emailOrPhone: $emailOrPhone } }) {
      id
      name
      username
      email
      phone
      photo
      emailOrPhone
    }
  }
`

export const REMOVE_TEAM_MEMBER = gql`
  mutation RemoveTeamMember($id: ID!, $teamMemberID: String!) {
    removeTeamMember(input: { id: $id, teamMemberID: $teamMemberID }) {
      id
      name
      username
      email
      phone
      photo
      emailOrPhone
    }
  }
`

export const ASSIGN_DISPATCHER = gql`
  mutation AssignDispatcher(
    $shipmentID: ID!
    $shipmentNumber: String!
    $dispatcher: DispatcherDetails!
    $addedByWorkspaceID: ID
  ) {
    assignDispatcher(
      input: {
        shipmentID: $shipmentID
        shipmentNumber: $shipmentNumber
        dispatcher: $dispatcher
        addedByWorkspaceID: $addedByWorkspaceID
      }
    ) {
      user {
        countryCode
        id
        name
        email
        phone
        photo
      }
      workspace {
        id
        displayName
        workspacename
      }
      membership {
        userID
        workspaceID
        role
        accessType
      }
    }
  }
`

export const UNASSIGN_DISPATCHER = gql`
  mutation UnassignDispatcher(
    $shipmentID: ID!
    $dispatcherID: ID!
    $dispatcherWorkspaceID: ID
    $removedByWorkspaceID: ID
  ) {
    unassignDispatcher(
      input: {
        shipmentID: $shipmentID
        dispatcherID: $dispatcherID
        dispatcherWorkspaceID: $dispatcherWorkspaceID
        removedByWorkspaceID: $removedByWorkspaceID
      }
    ) {
      user {
        id
      }
    }
  }
`

export const ASSIGN_DRIVER = gql`
  mutation AssignDriver($shipmentID: ID!, $shipmentNumber: String!, $driver: DriverDetails!, $addedByWorkspaceID: ID) {
    assignDriver(
      input: {
        shipmentID: $shipmentID
        shipmentNumber: $shipmentNumber
        driver: $driver
        addedByWorkspaceID: $addedByWorkspaceID
      }
    ) {
      user {
        countryCode
        id
        name
        email
        phone
        photo
      }
      workspace {
        id
        displayName
        workspacename
      }
      membership {
        userID
        workspaceID
        role
        accessType
      }
    }
  }
`

export const UNASSIGN_DRIVER = gql`
  mutation UnassignDriver($shipmentID: ID!, $driverID: ID!, $driverWorkspaceID: ID, $removedByWorkspaceID: ID) {
    unassignDriver(
      input: {
        shipmentID: $shipmentID
        driverID: $driverID
        driverWorkspaceID: $driverWorkspaceID
        removedByWorkspaceID: $removedByWorkspaceID
      }
    ) {
      user {
        countryCode
        id
        name
        email
        phone
        photo
      }
      workspace {
        id
        displayName
        workspacename
      }
      membership {
        userID
        workspaceID
        role
        accessType
      }
    }
  }
`

export const INITIATE_VERIFICATION_FOR_WORKSPACE_MEMBER = gql`
  mutation InitiateVerificationForWorkspaceMember($workspaceID: ID!, $workspaceMemberUserID: ID!) {
    initiateVerificationForWorkspaceMember(
      input: { workspaceID: $workspaceID, workspaceMemberUserID: $workspaceMemberUserID }
    ) {
      id
    }
  }
`

export const VERIFY_CODE_FOR_WORKSPACE_MEMBER = gql`
  mutation VerifyCodeForWorkspaceMember($workspaceID: ID!, $code: String!) {
    verifyCodeForWorkspaceMember(input: { workspaceID: $workspaceID, code: $code }) {
      id
    }
  }
`
